export function formatToLocaleString(value: string, locale = 'ru-RU'): string {
    const numericValue = value.replace(/\D/g, '');

    return numericValue ? Number(numericValue).toLocaleString(locale) : '';
}

export function filteredList(list: {id: number, name: string}[], searchString: string) {
    if(!searchString) return list;

    const regexp = new RegExp(searchString, "gi");

    return list.filter(value => {
        return regexp.test(value.name);
    });
}